import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

import type { PageHeaderVariant } from './types';
import { PAGE_HEADER_PADDING } from './types';

export interface PageHeaderContainerProps {
  children: ReactNode;
  variant?: PageHeaderVariant;
}

const PageHeaderContainer: React.FC<PageHeaderContainerProps> = ({
  children,
  variant = 'pageHeader',
}) => {
  return (
    <Box
      sx={{
        padding: PAGE_HEADER_PADDING[variant],
        minHeight: 48,
      }}
    >
      {children}
    </Box>
  );
};

export default PageHeaderContainer;
